export default __webpack_public_path__ + "static/media/carousel1.b458d987.png";